import dayjs from "@config/dayjs";
import type { CurriculumTeachingDatesDisplay } from "../../types";

const TEACHING_START_DATE_TAG = "ue.es/teaching_start_date";
const TEACHING_END_DATE_TAG = "ue.es/teaching_end_date";

const isTagMap = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const formatTeachingDate = (value: unknown): string => {
  if (typeof value !== "string") return "";

  const parsedDate = dayjs(value.trim(), "YYYY-MM-DD", true);
  return parsedDate.isValid() ? parsedDate.format("DD-MM-YYYY") : "";
};

const readTeachingDate = (tags: Record<string, unknown>, tagCode: string): string | undefined =>
  Object.hasOwn(tags, tagCode) ? formatTeachingDate(tags[tagCode]) : undefined;

/**
 * Maps the curriculum's own date tags to display values. Key presence determines
 * visibility, so an empty or invalid value remains an empty string.
 */
export const getCurriculumTeachingDatesDisplay = (
  tags: unknown,
): CurriculumTeachingDatesDisplay => {
  if (!isTagMap(tags)) return {};

  return {
    start: readTeachingDate(tags, TEACHING_START_DATE_TAG),
    end: readTeachingDate(tags, TEACHING_END_DATE_TAG),
  };
};
